import { render, staticRenderFns } from "./ContainerVideos.vue?vue&type=template&id=25c074f5&scoped=true"
import script from "./ContainerVideos.vue?vue&type=script&lang=ts"
export * from "./ContainerVideos.vue?vue&type=script&lang=ts"
import style0 from "./ContainerVideos.scss?vue&type=style&index=0&id=25c074f5&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c074f5",
  null
  
)

export default component.exports